import React from 'react';
import JoinRoomModal from "./JoinRoomModal";
import RoomJoinRejectModal from "./RoomJoinRejectModal";
import FinishModal from "./FinishModal";
import TrumpCardModal from "./TrumpCardModal";
import WaitingForPlayerModal from "./WaitingForPlayerModal";
import AnnounceCombinationModal from "./AnnounceCombinationModal";
import AnnounceCombinationRankModal from "./AnnounceCombinationRankModal";
import PublishCombinationModal from "./PublishCombinationModal";
import {useSelector} from "react-redux";
import AcceptPassAllCardsToOpponentModal from "./AcceptPassAllCardsToOpponentModal";
import AcceptPassAllCardsToMeModal from "./AcceptPassAllCardsToMeModal";
import PassRoomAllCardsToMeModal from "./PassRoomAllCardsToMeModal";
import LogoutModal from "./LogoutModal";
import SafeDynamicComponent from "../../SafeDynamicComponent.jsx";

const CombinedModals = {
    FinishModal,
    JoinRoomModal,
    TrumpCardModal,
    AcceptPassAllCardsToOpponentModal,
    AcceptPassAllCardsToMeModal,
    PassRoomAllCardsToMeModal,
    WaitingForPlayerModal,
    RoomJoinRejectModal,
    AnnounceCombinationModal,
    AnnounceCombinationRankModal,
    PublishCombinationModal,
    LogoutModal
};

function RoomModal({roomId, userId, currency}) {
    const rooms = useSelector(state => state.rooms);
    const room = rooms[roomId];
    if (!room) return null;

    if (room.closeRoomModal) {
        return <LogoutModal room={room} userId={userId}/>;
    }

    const ActiveModal = room.modal?.isActive && room.modal?.name ? CombinedModals[room.modal.name] : null;
    if (!ActiveModal) return;
    return <SafeDynamicComponent
            Component={ActiveModal}
            room={room}
            userId={userId}
            currency={currency}
    />
}

export default RoomModal
